/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Admin BFF API
 * Authentication and admin gateway for the AvilaRoffe platform.
 * OpenAPI spec version: 1.0
 */
import type {
  AuthErrorResponse,
  AuthLoginRequest,
  AuthOtpSendRequest,
  AuthOtpVerifyRequest,
  AuthSsoCallbackRequest,
  AuthTokenPairResponse,
  Body2Body,
  GetAuthConfigTenantSlug200,
  GetAuthSsoProviderRedirect200,
  GetAuthSsoProviderRedirectParams,
  PostAuthOtpSend200
} from '../adminBFFAPI.schemas';

import { adminBffFetch } from '../../mutator';

/**
 * @summary Get auth configuration for a tenant
 */
export type getAuthConfigTenantSlugResponse200 = {
  data: GetAuthConfigTenantSlug200
  status: 200
}

export type getAuthConfigTenantSlugResponse404 = {
  data: AuthErrorResponse
  status: 404
}
    
export type getAuthConfigTenantSlugResponseSuccess = (getAuthConfigTenantSlugResponse200) & {
  headers: Headers;
};
export type getAuthConfigTenantSlugResponseError = (getAuthConfigTenantSlugResponse404) & {
  headers: Headers;
};

export type getAuthConfigTenantSlugResponse = (getAuthConfigTenantSlugResponseSuccess | getAuthConfigTenantSlugResponseError)

export const getGetAuthConfigTenantSlugUrl = (tenantSlug: string,) => {


  

  return `/auth/config/${tenantSlug}`
}

export const getAuthConfigTenantSlug = async (tenantSlug: string, options?: RequestInit): Promise<getAuthConfigTenantSlugResponse> => {
  
  return adminBffFetch<getAuthConfigTenantSlugResponse>(getGetAuthConfigTenantSlugUrl(tenantSlug),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * @summary Email/password login
 */
export type postAuthLoginResponse200 = {
  data: AuthTokenPairResponse
  status: 200
}

export type postAuthLoginResponse400 = {
  data: AuthErrorResponse
  status: 400
}

export type postAuthLoginResponse401 = {
  data: AuthErrorResponse
  status: 401
}

export type postAuthLoginResponse500 = {
  data: AuthErrorResponse
  status: 500
}
    
export type postAuthLoginResponseSuccess = (postAuthLoginResponse200) & {
  headers: Headers;
};
export type postAuthLoginResponseError = (postAuthLoginResponse400 | postAuthLoginResponse401 | postAuthLoginResponse500) & {
  headers: Headers;
};

export type postAuthLoginResponse = (postAuthLoginResponseSuccess | postAuthLoginResponseError)

export const getPostAuthLoginUrl = () => {


  

  return `/auth/login`
}

export const postAuthLogin = async (authLoginRequest: AuthLoginRequest, options?: RequestInit): Promise<postAuthLoginResponse> => {
  
  return adminBffFetch<postAuthLoginResponse>(getPostAuthLoginUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      authLoginRequest,)
  }
);}


/**
 * @summary Revoke refresh token and end session
 */
export type postAuthLogoutResponse204 = {
  data: void
  status: 204
}

export type postAuthLogoutResponse401 = {
  data: AuthErrorResponse
  status: 401
}
    
export type postAuthLogoutResponseSuccess = (postAuthLogoutResponse204) & {
  headers: Headers;
};
export type postAuthLogoutResponseError = (postAuthLogoutResponse401) & {
  headers: Headers;
};

export type postAuthLogoutResponse = (postAuthLogoutResponseSuccess | postAuthLogoutResponseError)

export const getPostAuthLogoutUrl = () => {


  

  return `/auth/logout`
}

export const postAuthLogout = async (body2Body: Body2Body, options?: RequestInit): Promise<postAuthLogoutResponse> => {
  
  return adminBffFetch<postAuthLogoutResponse>(getPostAuthLogoutUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      body2Body,)
  }
);}


/**
 * @summary Send a one-time password to the given email
 */
export type postAuthOtpSendResponse200 = {
  data: PostAuthOtpSend200
  status: 200
}

export type postAuthOtpSendResponse400 = {
  data: AuthErrorResponse
  status: 400
}

export type postAuthOtpSendResponse429 = {
  data: AuthErrorResponse
  status: 429
}

export type postAuthOtpSendResponse500 = {
  data: AuthErrorResponse
  status: 500
}
    
export type postAuthOtpSendResponseSuccess = (postAuthOtpSendResponse200) & {
  headers: Headers;
};
export type postAuthOtpSendResponseError = (postAuthOtpSendResponse400 | postAuthOtpSendResponse429 | postAuthOtpSendResponse500) & {
  headers: Headers;
};

export type postAuthOtpSendResponse = (postAuthOtpSendResponseSuccess | postAuthOtpSendResponseError)

export const getPostAuthOtpSendUrl = () => {


  

  return `/auth/otp/send`
}

export const postAuthOtpSend = async (authOtpSendRequest: AuthOtpSendRequest, options?: RequestInit): Promise<postAuthOtpSendResponse> => {
  
  return adminBffFetch<postAuthOtpSendResponse>(getPostAuthOtpSendUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      authOtpSendRequest,)
  }
);}


/**
 * @summary Verify a one-time password and issue token pair
 */
export type postAuthOtpVerifyResponse200 = {
  data: AuthTokenPairResponse
  status: 200
}

export type postAuthOtpVerifyResponse400 = {
  data: AuthErrorResponse
  status: 400
}

export type postAuthOtpVerifyResponse401 = {
  data: AuthErrorResponse
  status: 401
}

export type postAuthOtpVerifyResponse429 = {
  data: AuthErrorResponse
  status: 429
}

export type postAuthOtpVerifyResponse500 = {
  data: AuthErrorResponse
  status: 500
}
    
export type postAuthOtpVerifyResponseSuccess = (postAuthOtpVerifyResponse200) & {
  headers: Headers;
};
export type postAuthOtpVerifyResponseError = (postAuthOtpVerifyResponse400 | postAuthOtpVerifyResponse401 | postAuthOtpVerifyResponse429 | postAuthOtpVerifyResponse500) & {
  headers: Headers;
};

export type postAuthOtpVerifyResponse = (postAuthOtpVerifyResponseSuccess | postAuthOtpVerifyResponseError)

export const getPostAuthOtpVerifyUrl = () => {


  

  return `/auth/otp/verify`
}

export const postAuthOtpVerify = async (authOtpVerifyRequest: AuthOtpVerifyRequest, options?: RequestInit): Promise<postAuthOtpVerifyResponse> => {
  
  return adminBffFetch<postAuthOtpVerifyResponse>(getPostAuthOtpVerifyUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      authOtpVerifyRequest,)
  }
);}


/**
 * @summary Complete SSO callback — exchange code, issue JWT
 */
export type postAuthSsoCallbackResponse200 = {
  data: AuthTokenPairResponse
  status: 200
}

export type postAuthSsoCallbackResponse400 = {
  data: AuthErrorResponse
  status: 400
}

export type postAuthSsoCallbackResponse401 = {
  data: AuthErrorResponse
  status: 401
}

export type postAuthSsoCallbackResponse403 = {
  data: AuthErrorResponse
  status: 403
}
    
export type postAuthSsoCallbackResponseSuccess = (postAuthSsoCallbackResponse200) & {
  headers: Headers;
};
export type postAuthSsoCallbackResponseError = (postAuthSsoCallbackResponse400 | postAuthSsoCallbackResponse401 | postAuthSsoCallbackResponse403) & {
  headers: Headers;
};

export type postAuthSsoCallbackResponse = (postAuthSsoCallbackResponseSuccess | postAuthSsoCallbackResponseError)

export const getPostAuthSsoCallbackUrl = () => {


  

  return `/auth/sso/callback`
}

export const postAuthSsoCallback = async (authSsoCallbackRequest: AuthSsoCallbackRequest, options?: RequestInit): Promise<postAuthSsoCallbackResponse> => {
  
  return adminBffFetch<postAuthSsoCallbackResponse>(getPostAuthSsoCallbackUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      authSsoCallbackRequest,)
  }
);}


/**
 * @summary Get SSO redirect URL for the given provider
 */
export type getAuthSsoProviderRedirectResponse200 = {
  data: GetAuthSsoProviderRedirect200
  status: 200
}

export type getAuthSsoProviderRedirectResponse400 = {
  data: AuthErrorResponse
  status: 400
}
    
export type getAuthSsoProviderRedirectResponseSuccess = (getAuthSsoProviderRedirectResponse200) & {
  headers: Headers;
};
export type getAuthSsoProviderRedirectResponseError = (getAuthSsoProviderRedirectResponse400) & {
  headers: Headers;
};

export type getAuthSsoProviderRedirectResponse = (getAuthSsoProviderRedirectResponseSuccess | getAuthSsoProviderRedirectResponseError)

export const getGetAuthSsoProviderRedirectUrl = (provider: string,
    params: GetAuthSsoProviderRedirectParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/sso/${provider}/redirect?${stringifiedParams}` : `/auth/sso/${provider}/redirect`
}

export const getAuthSsoProviderRedirect = async (provider: string,
    params: GetAuthSsoProviderRedirectParams, options?: RequestInit): Promise<getAuthSsoProviderRedirectResponse> => {
  
  return adminBffFetch<getAuthSsoProviderRedirectResponse>(getGetAuthSsoProviderRedirectUrl(provider,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * @summary Refresh access token using a refresh token
 */
export type postAuthTokenRefreshResponse200 = {
  data: AuthTokenPairResponse
  status: 200
}

export type postAuthTokenRefreshResponse401 = {
  data: AuthErrorResponse
  status: 401
}

export type postAuthTokenRefreshResponse500 = {
  data: AuthErrorResponse
  status: 500
}
    
export type postAuthTokenRefreshResponseSuccess = (postAuthTokenRefreshResponse200) & {
  headers: Headers;
};
export type postAuthTokenRefreshResponseError = (postAuthTokenRefreshResponse401 | postAuthTokenRefreshResponse500) & {
  headers: Headers;
};

export type postAuthTokenRefreshResponse = (postAuthTokenRefreshResponseSuccess | postAuthTokenRefreshResponseError)

export const getPostAuthTokenRefreshUrl = () => {


  

  return `/auth/token/refresh`
}

export const postAuthTokenRefresh = async (body2Body: Body2Body, options?: RequestInit): Promise<postAuthTokenRefreshResponse> => {
  
  return adminBffFetch<postAuthTokenRefreshResponse>(getPostAuthTokenRefreshUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      body2Body,)
  }
);}


